import { Title } from "../../../../../library/title";
import {
  DetailsRow,
  LeftDetailsCol,
  ThumbnailWrapper,
  ThumbnailCol,
  Thumbnail,
  InformationCol,
  RightDetailsCol,
  TitleBadge,
  DetailsWrapper,
  BadgeWrapper,
} from "./styled";
import { Text } from "../../../../../library/text";
import thumbnail from "../../../../../assets/img/thumbnail.svg";
import Skeleton from "react-loading-skeleton";
import { formatFirebaseTime } from "../../../../../utils/date-format";
import { useAuth } from "../../../../../AuthContext";

const UpperArea = () => {
  const { currentUser, loading } = useAuth();

  const renderText = () => {
    if (loading) {
      return (
        <>
          <Skeleton width={200} height={30} />
          <Skeleton width={150} height={20} />
        </>
      );
    }

    return (
      <DetailsWrapper>
        <BadgeWrapper>
          <TitleBadge color="blue">
            {currentUser?.workspaces?.length
              ? currentUser.workspaces.length
              : "Ingen"}{" "}
            arbeidsmiljø
          </TitleBadge>
        </BadgeWrapper>
        <Title size="md">
          {currentUser?.firstName} {currentUser?.lastName}
        </Title>
        <Text size="small" color="dark">
          Medlem siden{" "}
          {currentUser?.registerDate
            ? formatFirebaseTime(currentUser.registerDate)
            : "ukjent tid"}
        </Text>
      </DetailsWrapper>
    );
  };

  return (
    <DetailsRow>
      <LeftDetailsCol>
        <ThumbnailCol>
          <ThumbnailWrapper>
            <Thumbnail src={thumbnail} />
          </ThumbnailWrapper>
        </ThumbnailCol>
        <InformationCol>{renderText()}</InformationCol>
      </LeftDetailsCol>
      <RightDetailsCol></RightDetailsCol>
    </DetailsRow>
  );
};

export default UpperArea;
